<template>
  <div class="impressao-icone">
    <div
      v-if="!selecionadoCheck"
      v-b-tooltip.hover.top
      title="Selecione um ou mais impostos"
      class="impressao-btn"
    >
      <div class="impressao-print-icon">
        <font-awesome-icon icon="print" />
      </div>
      <h2 for="Imprimir">Imprimir</h2>
    </div>
    <div v-else class="impressao-btn" @click="handlePrint">
      <div class="impressao-print-icon">
        <font-awesome-icon icon="print" />
      </div>
      <h2 for="Imprimir">Imprimir</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalImpressaoBotao",
  props: {
    selecionadoCheck: Boolean,
    handlePrint: Function
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";

.impressao-icone {
  width: 100%;
  height: 56px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 35px;
  text-align: center;
  color: var(--branco);
  border-top: 1px solid $bordaCinza;
  cursor: pointer;
  user-select: none;
  background: $backgroundBege;
  h2 {
    font-size: 13px;
    text-transform: uppercase;
    font-family: "Roboto Condensed";
  }
}
.impressao-print-icon {
  font-size: 20px;
  margin: 0 4px;
}
.impressao-btn {
  height: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  background: $corImpressao;
  margin: 10px;
  transition: all 0.15s ease-in-out;
  // box-shadow: 1px 1px 2px #9ea2a7;
  h2 {
    margin: 0 4px;
  }
}
.impressao-btn:hover {
  background: $corImpressaoHover;
}
</style>
